export const SET_TIMELINE = "SET_TIMELINE";
export const ADD_TIMELINE_TICKET_IDS = "ADD_TIMELINE_TICKET_IDS";
export const ADD_ACTIVITY = "ADD_ACTIVITY";
export const UPDATE_ACTIVITY = "UPDATE_ACTIVITY";
export const ADD_CONTACT_ACTIVITY = "ADD_CONTACT_ACTIVITY";
